import { Goal } from '@/modules/goal/models/Goal';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { Situation } from '@/modules/situation/models/Situation';

export class LightDiagnosticSubmission extends BaseEntityModel {
  id?: number;
  userId?: number;
  estateId?: number;
  goalId?: number;
  situationId?: number;
  email?: string;
  recommendation?: string;
  origin?: string;
  submittedOnDate?: string;

  goal?: Relationship<Goal> | null;
  situation?: Relationship<Situation> | null;

  constructor(model: Partial<LightDiagnosticSubmission> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.estateId = model.estateId;
    this.goalId = model.goalId;
    this.situationId = model.situationId;
    this.email = model.email;
    this.recommendation = model.recommendation;
    this.origin = model.origin;
    this.submittedOnDate = model.submittedOnDate;

    this.goal = Goal.mapModelOrNull(model.goal);
    this.situation = Situation.mapModelOrNull(model.situation);
  }
}
